module.exports = __webpack_public_path__ + "static/media/console.3e6d077a.svg";